import React from 'react';
import {Dropdown} from 'react-bootstrap';
import './BpmAnimationSelect.css';

const bpmAnimationOptions = [
  {
    animation: 'shake-no',
    name: 'No animation',
  },
  {
    animation: 'shake-hard',
    name: 'Hard shake',
  },
  {
    animation: 'shake-slow',
    name: 'Slow shake',
  },
  {
    animation: 'shake-horizontal',
    name: 'Horizontal shake',
  },
  {
    animation: 'shake-opacity',
    name: 'Opacity shake',
  },
  {
    animation: 'shake-crazy',
    name: 'Crazy shake',
  },
  {
    animation: 'shake-little',
    name: 'Little shake',
  },
  {
    animation: 'shake',
    name: 'Basic shake',
  },
  {
    animation: 'shake-vertical',
    name: 'Vertical shake',
  },
  {
    animation: 'shake-rotate',
    name: 'Rotate shake',
  },
  {
    animation: 'shake-chunk',
    name: 'Chunk shake',
  },
];

export const BpmAnimationSelect = ({onChange, value}) => {
  return (
    <Dropdown style={{width: '200px'}}>
      <Dropdown.Toggle variant={'outline-info'}>
        {bpmAnimationOptions.find(({animation}) => animation === value)
          ? bpmAnimationOptions.find(({animation}) => animation === value).name
          : bpmAnimationOptions[0].name}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {bpmAnimationOptions.map(({animation, name}) => {
          return (
            <Dropdown.Item key={name} eventKey={animation} onSelect={onChange}>
              <span className={animation + ' shake-constant'}>{name}</span>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};
